import "./App.css";
import Courses from "./components/Courses";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import ContactUs from "./pages/ContactUs";
import ContactUsOld from "./pages/ContactUsOld";
import WebDesign from "./pages/WebDesign";
import MobileApp from "./pages/MobileApp";
import Ecommerce from "./pages/Ecommerce";
import UIUX from "./pages/UIUX";
import DigitalMarketing from "./pages/DigitalMarketing";
import Careers from "./pages/Careers";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Services from "./pages/Services";
import BlogPage from "./pages/BlogPage";
import Blog from "./pages/Blog";
import ProgrammaticAdvertising from "./pages/ProgrammaticAdvertising";
import AdOperations from "./pages/AdOperations";
import AboutAuthor from "./pages/AboutAuthor";
import PayPerClick from "./pages/PayPerClick";
import SEO from "./pages/SEO";
import PublishersManagement from "./pages/PublishersManagement";
import SocialMediaManagement from "./pages/SocialMediaManagement";
import Branding from "./pages/Branding";
import ConversionRateOptimization from "./pages/ConversionRateOptimization";
import EndToEndAnalytics from "./pages/EndToEndAnalytics";
import DataVisualization from "./pages/DataVisualization";
import GoogleAnalytics from "./pages/GoogleAnalytics";
import VideoProduction from "./pages/VideoProduction";
import ContentMarketing from "./pages/ContentMarketing";
import NewPost from "./pages/NewPost";
import Case from "./pages/Case";
import CasePage from "./pages/CasePage";
import NewCase from "./pages/NewCase";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import HTMLSitemap from "./pages/HTMLSitemap";
import Oops from "./pages/Oops";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Compliance from "./pages/Compliance";

function App() {
  const dispatch = useDispatch();

  const [deviceType, setDeviceType] = useState("PC");

  useEffect(() => {
    const determineDeviceType = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      if (width < 768) {
        return "MOBILE";
      } else if (width >= 768 && width < 1024) {
        return height > width ? "TABP" : "TABL";
      } else {
        return "PC";
      }
    };

    // Set device type immediately
    dispatch({ type: "CHANGE_VIEW", payload: determineDeviceType() });

    const handleResize = () => {
      dispatch({ type: "CHANGE_VIEW", payload: determineDeviceType() });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Your component logic using deviceType

  // Component to enforce trailing slashes
  function EnforceTrailingSlash({ children }) {
    const { pathname } = useLocation();
    // Check if the pathname does not end with a slash (excluding root path)
    if (pathname !== "/" && !pathname.endsWith("/")) {
      // Redirect to the same URL with a trailing slash
      return <Navigate to={`${pathname}/`} replace />;
    }

    // If the pathname already has a trailing slash, render the children
    return children;
  }

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <EnforceTrailingSlash>
              <Dashboard />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/about-us/"
          element={
            <EnforceTrailingSlash>
              <About />
            </EnforceTrailingSlash>
          }
        />

        <Route
          path="/uiux/"
          element={
            <EnforceTrailingSlash>
              <UIUX />
            </EnforceTrailingSlash>
          }
        />

        <Route
          path="/web-design/"
          element={
            <EnforceTrailingSlash>
              <WebDesign />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/mobile-application-development/"
          element={
            <EnforceTrailingSlash>
              <MobileApp />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/e-commerce/"
          element={
            <EnforceTrailingSlash>
              <Ecommerce />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/digital-marketing/"
          element={
            <EnforceTrailingSlash>
              <DigitalMarketing />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/contact-us/"
          element={
            <EnforceTrailingSlash>
              <ContactUs />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/get-a-quote/"
          element={
            <EnforceTrailingSlash>
              <ContactUsOld />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/careers/"
          element={
            <EnforceTrailingSlash>
              <Careers />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/blog/"
          element={
            <EnforceTrailingSlash>
              <Blog />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/about-author/:auth_id/"
          element={
            <EnforceTrailingSlash>
              <AboutAuthor />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/blog/:post/"
          element={
            <EnforceTrailingSlash>
              <BlogPage />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/new_post/"
          element={
            <EnforceTrailingSlash>
              <NewPost />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/casestudies/"
          element={
            <EnforceTrailingSlash>
              <Case />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/casestudies/:post/"
          element={
            <EnforceTrailingSlash>
              <CasePage />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/new_case_study/"
          element={
            <EnforceTrailingSlash>
              <NewCase />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/logout/"
          element={
            <EnforceTrailingSlash>
              <Logout />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/login/"
          element={
            <EnforceTrailingSlash>
              <Login />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/forgot-password/"
          element={
            <EnforceTrailingSlash>
              <ForgotPassword />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/reset-password/"
          element={
            <EnforceTrailingSlash>
              <ResetPassword />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/programmatic-advertising/"
          element={
            <EnforceTrailingSlash>
              <ProgrammaticAdvertising />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/ad-operations/"
          element={
            <EnforceTrailingSlash>
              <AdOperations />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/pay-per-click/"
          element={
            <EnforceTrailingSlash>
              <PayPerClick />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/search-engine-optimization/"
          element={
            <EnforceTrailingSlash>
              <SEO />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/publishers-management/"
          element={
            <EnforceTrailingSlash>
              <PublishersManagement />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/social-media-management/"
          element={
            <EnforceTrailingSlash>
              <SocialMediaManagement />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/branding/"
          element={
            <EnforceTrailingSlash>
              <Branding />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/conversion-rate-optimization/"
          element={
            <EnforceTrailingSlash>
              <ConversionRateOptimization />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/end-to-end-analytics/"
          element={
            <EnforceTrailingSlash>
              <EndToEndAnalytics />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/data-visualization/"
          element={
            <EnforceTrailingSlash>
              <DataVisualization />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/google-analytics-setup/"
          element={
            <EnforceTrailingSlash>
              <GoogleAnalytics />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/video-production/"
          element={
            <EnforceTrailingSlash>
              <VideoProduction />
            </EnforceTrailingSlash>
          }
        />
        <Route
          path="/content-marketing/"
          element={
            <EnforceTrailingSlash>
              <ContentMarketing />
            </EnforceTrailingSlash>
          }
        />

        <Route
          path="/terms-of-service/"
          element={
            <EnforceTrailingSlash>
              <TermsOfService />
            </EnforceTrailingSlash>
          }
        />

        <Route
          path="/privacy-policy/"
          element={
            <EnforceTrailingSlash>
              <PrivacyPolicy />
            </EnforceTrailingSlash>
          }
        />

        <Route
          path="/compliance/"
          element={
            <EnforceTrailingSlash>
              <Compliance />
            </EnforceTrailingSlash>
          }
        />

        <Route
          path="/sitemap/"
          element={
            <EnforceTrailingSlash>
              <HTMLSitemap />
            </EnforceTrailingSlash>
          }
        />

        {/* 404 Not Found Route - This should be the last route */}
        <Route path="*" element={<Oops />} />
      </Routes>
    </div>
  );
}

export default App;
